import styled from '@emotion/styled/macro';

export const TabModeToggleContainer = styled.div`
  position: absolute;
  top: 30px;
  right: 30px;
  line-height: 0;
`;

export const SDKContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 360px;
  min-height: 130px;
  margin: 0 auto;
  h1,
  p:not(:last-of-type) {
    display: none;
  }
`;
